import { Navigate } from "react-router-dom";
import { usePartner } from "./PartnerContext";

export const PartnerPermissionGate = ({ any = [], ownerOnly = false, children }) => {
  const { internalRole, canAny } = usePartner();
  const allowed = ownerOnly ? internalRole === "OWNER" : !any.length || canAny(any);
  if (!allowed) return <Navigate to="/partenaire" replace />;
  return children;
};